export const openInNewTab = (url: string) => {
  // 'noopener,noreferrer' is used to prevent the new tab from being treated as a popup window
  window.open(url, '_blank', 'noopener,noreferrer');
};
